import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import Item from './Item'

export default class TopicCloudList extends PureComponent {
  render() {
    const { dispatch, topics, currentTopic, user } = this.props
    const topicsList = topics.map(function (topic, index) {
      return (
        <Item
          topic={topic}
          isSelected={currentTopic ? currentTopic.id === topic.id : false}
          key={index}
          dispatch={dispatch}
          user={user}
        />
      )
    })

    return <ul>{topicsList}</ul>
  }
}

TopicCloudList.propTypes = {
  dispatch: PropTypes.func,
  topics: PropTypes.array,
  currentTopic: PropTypes.object,
  user: PropTypes.object
}



// WEBPACK FOOTER //
// ./src/components/topiccloud/topicmenu/List.js